import axios from '../index';

// 短信码发送（找回密码）
export const forgetSendCode = (data) => {
  return axios.post('/api/sendResetPasswordVerifyCode', data);
};

// 短信重置密码（验证码）
export const forgetPassVerifyCode = (data) => {
  return axios.post('/api/verifyResetPasswordCode', data);
};

// 短信重置密码（重置密码）
export const forgetPassSubmit = (data) => {
  return axios.post('/api/resetPassword', data);
};
